export enum HyperMetroDomainTypeE {
    Block = 1,
    File = 2,
    FsMoveDomain = 3
}

export enum RoleE {
    NonPreferred = 0,
    Preferred = 1
}

export enum ConfigRoleE {
    Slave = 0,
    Master = 1
}

export enum ServiceStatusE {
    Active = 0,
    Passive = 1
}

export enum RunningStatusE {
    Normal = 0,
    Starting = 1,
    Fail = 2,
    Split = 3,
    ForceStart = 4,
    Invalid = 5
}

export enum RecoverPolicyE {
    Auto = '1',
    Manul = '2'
}

/**
 * 文件系统双活域工作模式
 */
export enum WorkModeE {
    /**
     * 双活模式
     */
    HyperMetro = '0',
    /**
     * 同步模式
     */
    Sync = '1',
    /**
     * AP双活模式
     */
    AP = '2'
}

/**
 * 文件系统双活域切换场景
 */
export enum SwitchFsDomainSceneE {
    // 工作模式切换 AA-->AP AP-->AA
    WorkMode = 0,

    // AA模式下的工作站点切换
    AAWorkSite = 1,

    // AP模式下的主从切换
    APFailover = 2
}

/**
 * 文件系统AP双活域本端是否提供服务
 */
export enum LocalAccessModeStatusE {
    Provide = '1',
    NotProvide = '2',
}

export enum preferredSiteObjE {
    /**
     * 用户自定义
     */
    Custom = 1,
    /**
     * 与激活端保持一致
     */
    SameWithActive = 2
}

export enum AARunOwnSiteObjE {
    no = 'false',
    yes = 'true',
}
/**
 * 资源access
 */
export enum ResourceAccessE {
    NoAccess = '1',
    ReadOnly = '2',
    ReadAndWrite = '3'
}

/**
 * lif激活状态
 */
export enum LifStatusE {
    Active = '1',
    Inactive = '2'
}

/**
 * 双活域类型
 */
export enum DomaintypeE {
    AA = '1',
    AP = '2'
}

/**
 * 仲裁类型
 */
export enum CPTypeE {
    /** 仲裁服务器 */
    QUORUM = '1',
    /** 仲裁盘 */
    DISK = '2',
    /** 静态优先级 */
    STATIC = '3'
}

export enum CreatingAHyperResRunningStatusE {
    NORMAL = '1',
    TO_BE_REQUIRED = '33',
    INVALID = '35'
}

export enum switchPreferredSiteTypeE {
    type = '162'
}

/**
 * 是否保留仲裁服务器
 */
export enum ReserveQuorumServerStatusE {
    /**
     * 不保留仲裁
     */
    NOT_RETAINED = '0',
    /**
     * 保留仲裁
     */
    RETAINED = '1'
}
